// Hook do dodawania dokumentu dropshippingowego (etykieta lub protokol) do koszyka.
// Backend zapewnia, ze tylko ostatni dokument danego typu jest brany pod uwage.

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export type DropshippingDocumentType = 'dropshipping_label' | 'dropshipping_protocol';

export interface IRequest {
  cartId: number;
  type: DropshippingDocumentType;
  base64: string;
  name?: string;
  description?: string;
}

type IResponse = ICommandResponseSuccess & {
  data?: {
    cartId: number;
    attachmentId: number;
    type: DropshippingDocumentType;
    url: string | null;
  };
};

const postDropshippingDocument = ({ cartId, ...payload }: IRequest): Promise<IResponse> =>
  axios.post(`/order-edit/dropshipping/carts/${cartId}/documents`, payload);

export const usePostDropshippingDocument = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postDropshippingDocument(data), options);
